import React from "react";

export default function Nosotros() {
  return (
    <main className="w-full bg-background-dark text-text-light font-display">
      {/* Hero */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 text-center bg-card-dark">
        <h1 className="text-4xl md:text-5xl font-extrabold text-white">
          Tu mejor opción para el servicio de tu equipo
        </h1>
      </section>

      <div className="py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          {/* Quiénes Somos */}
          <section className="mb-16">
            <div className="text-center">
              <h2 className="text-3xl font-bold text-white mb-4">Quiénes Somos</h2>
              <p className="text-lg text-text-muted-dark max-w-3xl mx-auto">
                En TLC.MX, nos dedicamos apasionadamente a la comercialización de refacciones para turbocompresores. Nuestro compromiso es ofrecer productos de la más alta calidad y un servicio excepcional para garantizar el máximo rendimiento de tu motor. Con años de experiencia en el sector, somos tu aliado de confianza para todas tus necesidades de turbos.
              </p>
            </div>
          </section>

          {/* Nuestros Valores */}
          <section className="mb-16">
            <h2 className="text-3xl font-bold text-white text-center mb-10">Nuestros Valores</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
              <div className="bg-card-dark p-8 rounded-lg">
                <div className="mb-4">
                  <span className="material-symbols-outlined text-primary" style={{ fontSize: 48 }}>headset_mic</span>
                </div>
                <h3 className="text-xl font-bold text-white mb-2">Servicio al cliente</h3>
                <p className="text-text-muted-dark">
                  Nos esforzamos por superar las expectativas de nuestros clientes, ofreciendo atención personalizada y soluciones efectivas.
                </p>
              </div>
              <div className="bg-card-dark p-8 rounded-lg">
                <div className="mb-4">
                  <span className="material-symbols-outlined text-primary" style={{ fontSize: 48 }}>lightbulb</span>
                </div>
                <h3 className="text-xl font-bold text-white mb-2">Innovación</h3>
                <p className="text-text-muted-dark">
                  Buscamos constantemente nuevas tecnologías y procesos para ofrecer los productos más avanzados del mercado.
                </p>
              </div>
              <div className="bg-card-dark p-8 rounded-lg">
                <div className="mb-4">
                  <span className="material-symbols-outlined text-primary" style={{ fontSize: 48 }}>groups</span>
                </div>
                <h3 className="text-xl font-bold text-white mb-2">Respeto al trabajador</h3>
                <p className="text-text-muted-dark">
                  Valoramos a nuestro equipo, fomentando un ambiente de trabajo justo, seguro y colaborativo.
                </p>
              </div>
            </div>
          </section>

          {/* Misión y Visión */}
          <section className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
            <div className="bg-card-dark p-8 rounded-lg">
              <h2 className="text-3xl font-bold text-white mb-4">Misión</h2>
              <p className="text-lg text-text-muted-dark">
                Proveer al mercado nacional e internacional refacciones y turbocompresores de la más alta calidad, con un servicio al cliente inigualable, garantizando la satisfacción total y el óptimo desempeño de los equipos de nuestros clientes.
              </p>
            </div>
            <div className="bg-card-dark p-8 rounded-lg">
              <h2 className="text-3xl font-bold text-white mb-4">Visión</h2>
              <p className="text-lg text-text-muted-dark">
                Ser la empresa líder en México en la comercialización de turbocompresores, reconocida por nuestra innovación, calidad, y compromiso con nuestros clientes, empleados y la comunidad.
              </p>
            </div>
          </section>

          {/* CTA */}
          <section className="py-12 bg-primary text-center rounded-lg">
            <h3 className="text-2xl font-bold text-white max-w-4xl mx-auto">
              Ofrecemos soluciones de reparación personalizadas en nuestro centro especializado para satisfacer todas tus necesidades.
            </h3>
          </section>
        </div>
      </div>
    </main>
  );
}